import { Toaster as SonnerToaster } from "sonner";

// Single-place toast UI. We use Sonner because it's what shadcn now ships by
// default — lighter than the legacy Radix-toast variant.
export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "border border-border bg-card text-card-foreground shadow-lg",
        },
      }}
    />
  );
}
